import { css } from 'emotion';

export const button = css`
  svg {
    height: 16px;
    margin-right: 4px;
  }
`;

export const circleButton = css`
  margin-right: 20px;

  svg {
    height: 24px;
    width: 24px;
  }
`;
